import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function ShapeMorph({ values = {} }: { values?: FieldValues }) {
  const [isCircle, setIsCircle] = useState(false)
  const rotate = values.rotate ?? 180
  const scale = values.scale ?? 1.1
  const stiffness = values.stiffness ?? 200
  const damping = values.damping ?? 20
  const borderRadiusFrom = values.borderRadiusFrom ?? 12
  const borderRadiusTo = values.borderRadiusTo ?? 50

  useEffect(() => {
    const interval = setInterval(() => setIsCircle((v) => !v), 2000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center h-full">
      <motion.div
        animate={{
          borderRadius: isCircle ? `${borderRadiusTo}%` : `${borderRadiusFrom}px`,
          rotate: isCircle ? rotate : 0,
          scale: isCircle ? scale : 1,
        }}
        transition={{ type: 'spring', stiffness, damping }}
        className="w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-600 shadow-lg"
      />
    </div>
  )
}
